
// Definición de defaults

import { ExpedienteProps } from "../recepcion/ExpedienteInterface";
import { PaginacionProps } from "../global/PaginacionInterface";

export const defaultIncidente: IncidenteProps = {
    idIncidente: 0,
    secretario: '',
    url: '',
}

export const defaultConsultaIncidente: ConsultaIncidenteResponse = {
    recordsCount:       0,
    currentPageIndex:   0,
    pageCount:          0,
    records:            [],
}

// Creación de interfaces

export interface IncidenteProps {
    idIncidente:        number;
    secretario:         string;
    url:                string;
    fecha?:             Date;
}

export interface IncidentesPendientesParams {
    idExpediente:       number;    
}

export interface ConsultarIncidenteParams extends PaginacionProps {
    idAutoridad:        number;
    idMateria:          number;
    numeroExpediente:   string;
    fecha:              string;
}

export interface ConsultarIncidenteProps {
    idIncidente:            number;
    numeroExpediente:       string;
    numeroSentencia:        string;
    documentoIncidente:     string;
    documentoSentencia:     string;
    estatus:                string;
    idEstatus:              number;
    expediente:             ExpedienteProps;
    fecha?:                 Date;
    fechaConclusion?:       Date;
}

export interface ConsultaIncidenteResponse {
    recordsCount:       number;
    currentPageIndex:   number;
    pageCount:          number;
    records:            ConsultarIncidenteProps[];
}

export interface DescargarIncidentesParams {
    idAutoridad:        number;
    idMateria:          number;
    numeroExpediente:   string;
    fecha:              string;
}